/**
 * Do not edit directly, this file was auto-generated.
 */

export default {
  palette: {
    primary: {
      1: {
        key: "{palette.primary.1}",
        $value: {
          light: "(color.runtime.accent.light.1)",
          dark: "(color.runtime.accent.dark.1)",
        },
      },
      2: {
        key: "{palette.primary.2}",
        $value: {
          light: "(color.runtime.accent.light.2)",
          dark: "(color.runtime.accent.dark.2)",
        },
      },
      3: {
        key: "{palette.primary.3}",
        $value: {
          light: "(color.runtime.accent.light.3)",
          dark: "(color.runtime.accent.dark.3)",
        },
      },
      4: {
        key: "{palette.primary.4}",
        $value: {
          light: "(color.runtime.accent.light.4)",
          dark: "(color.runtime.accent.dark.4)",
        },
      },
      5: {
        key: "{palette.primary.5}",
        $value: {
          light: "(color.runtime.accent.light.5)",
          dark: "(color.runtime.accent.dark.5)",
        },
      },
      6: {
        key: "{palette.primary.6}",
        $value: {
          light: "(color.runtime.accent.light.6)",
          dark: "(color.runtime.accent.dark.6)",
        },
      },
      7: {
        key: "{palette.primary.7}",
        $value: {
          light: "(color.runtime.accent.light.7)",
          dark: "(color.runtime.accent.dark.7)",
        },
      },
      8: {
        key: "{palette.primary.8}",
        $value: {
          light: "(color.runtime.accent.light.8)",
          dark: "(color.runtime.accent.dark.8)",
        },
      },
      9: {
        key: "{palette.primary.9}",
        $value: {
          light: "(color.runtime.accent.light.9)",
          dark: "(color.runtime.accent.dark.9)",
        },
      },
      10: {
        key: "{palette.primary.10}",
        $value: {
          light: "(color.runtime.accent.light.10)",
          dark: "(color.runtime.accent.dark.10)",
        },
      },
      11: {
        key: "{palette.primary.11}",
        $value: {
          light: "(color.runtime.accent.light.11)",
          dark: "(color.runtime.accent.dark.11)",
        },
      },
      12: {
        key: "{palette.primary.12}",
        $value: {
          light: "(color.runtime.accent.light.12)",
          dark: "(color.runtime.accent.dark.12)",
        },
      },
      50: {
        key: "{palette.primary.50}",
        $value: {
          light: "(color.runtime.accent.light.3)",
          dark: "(color.runtime.accent.light.3)",
        },
      },
      100: {
        key: "{palette.primary.100}",
        $value: {
          light: "(color.runtime.accent.light.5)",
          dark: "(color.runtime.accent.light.5)",
        },
      },
      200: {
        key: "{palette.primary.200}",
        $value: {
          light: "(color.runtime.accent.light.6)",
          dark: "(color.runtime.accent.light.6)",
        },
      },
      300: {
        key: "{palette.primary.300}",
        $value: {
          light: "(color.runtime.accent.light.7)",
          dark: "(color.runtime.accent.light.7)",
        },
      },
      400: {
        key: "{palette.primary.400}",
        $value: {
          light: "(color.runtime.accent.dark.11)",
          dark: "(color.runtime.accent.dark.11)",
        },
      },
      500: {
        key: "{palette.primary.500}",
        $value: {
          light: "(color.runtime.accent.light.9)",
          dark: "(color.runtime.accent.light.9)",
        },
      },
      600: {
        key: "{palette.primary.600}",
        $value: {
          light: "(color.runtime.accent.light.11)",
          dark: "(color.runtime.accent.light.11)",
        },
      },
      700: {
        key: "{palette.primary.700}",
        $value: {
          light: "(color.runtime.accent.dark.6)",
          dark: "(color.runtime.accent.dark.6)",
        },
      },
      800: {
        key: "{palette.primary.800}",
        $value: {
          light: "(color.runtime.accent.dark.5)",
          dark: "(color.runtime.accent.dark.5)",
        },
      },
      900: {
        key: "{palette.primary.900}",
        $value: {
          light: "(color.runtime.accent.dark.4)",
          dark: "(color.runtime.accent.dark.4)",
        },
      },
      950: {
        key: "{palette.primary.950}",
        $value: {
          light: "(color.runtime.accent.dark.3)",
          dark: "(color.runtime.accent.dark.3)",
        },
      },
      lightest: {
        key: "{palette.primary.lightest}",
        $value: {
          light: "(color.runtime.accent.light.4)",
          dark: "(color.runtime.accent.light.4)",
        },
      },
      light: {
        key: "{palette.primary.light}",
        $value: {
          light: "(color.runtime.accent.dark.11)",
          dark: "(color.runtime.accent.dark.11)",
        },
      },
      main: {
        key: "{palette.primary.main}",
        $value: {
          light: "(color.runtime.accent.light.9)",
          dark: "(color.runtime.accent.dark.9)",
        },
      },
      dark: {
        key: "{palette.primary.dark}",
        $value: {
          light: "(color.runtime.accent.light.11)",
          dark: "(color.runtime.accent.light.11)",
        },
      },
      darkest: {
        key: "{palette.primary.darkest}",
        $value: {
          light: "(color.runtime.accent.dark.6)",
          dark: "(color.runtime.accent.dark.6)",
        },
      },
      contrast: {
        key: "{palette.primary.contrast}",
        $value: {
          light: "(color.runtime.accent.light.contrast)",
          dark: "(color.runtime.accent.dark.contrast)",
        },
      },
      borderRegular: {
        key: "{palette.primary.borderRegular}",
        $value: {
          light: "(color.runtime.accent.light.a7)",
          dark: "(color.runtime.accent.dark.a7)",
        },
      },
      track: {
        key: "{palette.primary.track}",
        $value: {
          light: "(color.runtime.accent.light.9)",
          dark: "(color.runtime.accent.dark.9)",
        },
      },
      a1: {
        key: "{palette.primary.a1}",
        $value: {
          light: "(color.runtime.accent.light.a1)",
          dark: "(color.runtime.accent.dark.a1)",
        },
      },
      a2: {
        key: "{palette.primary.a2}",
        $value: {
          light: "(color.runtime.accent.light.a2)",
          dark: "(color.runtime.accent.dark.a2)",
        },
      },
      a3: {
        key: "{palette.primary.a3}",
        $value: {
          light: "(color.runtime.accent.light.a3)",
          dark: "(color.runtime.accent.dark.a3)",
        },
      },
      a4: {
        key: "{palette.primary.a4}",
        $value: {
          light: "(color.runtime.accent.light.a4)",
          dark: "(color.runtime.accent.dark.a4)",
        },
      },
      a5: {
        key: "{palette.primary.a5}",
        $value: {
          light: "(color.runtime.accent.light.a5)",
          dark: "(color.runtime.accent.dark.a5)",
        },
      },
      a6: {
        key: "{palette.primary.a6}",
        $value: {
          light: "(color.runtime.accent.light.a6)",
          dark: "(color.runtime.accent.dark.a6)",
        },
      },
      a7: {
        key: "{palette.primary.a7}",
        $value: {
          light: "(color.runtime.accent.light.a7)",
          dark: "(color.runtime.accent.dark.a7)",
        },
      },
      a8: {
        key: "{palette.primary.a8}",
        $value: {
          light: "(color.runtime.accent.light.a8)",
          dark: "(color.runtime.accent.dark.a8)",
        },
      },
      a9: {
        key: "{palette.primary.a9}",
        $value: {
          light: "(color.runtime.accent.light.a9)",
          dark: "(color.runtime.accent.dark.a9)",
        },
      },
      a10: {
        key: "{palette.primary.a10}",
        $value: {
          light: "(color.runtime.accent.light.a10)",
          dark: "(color.runtime.accent.dark.a10)",
        },
      },
      a11: {
        key: "{palette.primary.a11}",
        $value: {
          light: "(color.runtime.accent.light.a11)",
          dark: "(color.runtime.accent.dark.a11)",
        },
      },
      a12: {
        key: "{palette.primary.a12}",
        $value: {
          light: "(color.runtime.accent.light.a12)",
          dark: "(color.runtime.accent.dark.a12)",
        },
      },
      indicator: {
        key: "{palette.primary.indicator}",
        $value: {
          light: "(color.runtime.accent.light.9)",
          dark: "(color.runtime.accent.dark.9)",
        },
      },
      surface: {
        key: "{palette.primary.surface}",
        $value: {
          light: "(color.runtime.accent.light.surface)",
          dark: "(color.runtime.accent.dark.surface)",
        },
      },
      borderSubtle: {
        key: "{palette.primary.borderSubtle}",
        $value: {
          light: "(color.runtime.accent.light.a6)",
          dark: "(color.runtime.accent.dark.a6)",
        },
      },
      backgroundSoft: {
        key: "{palette.primary.backgroundSoft}",
        $value: {
          light: "(color.runtime.accent.light.a3)",
          dark: "(color.runtime.accent.dark.a3)",
        },
      },
      text: {
        key: "{palette.primary.text}",
        $value: {
          light: "(color.runtime.accent.light.a11)",
          dark: "(color.runtime.accent.dark.a11)",
        },
      },
      solid: {
        key: "{palette.primary.solid}",
        $value: {
          light: "(color.runtime.accent.light.9)",
          dark: "(color.runtime.accent.dark.9)",
        },
      },
      solidHover: {
        key: "{palette.primary.solidHover}",
        $value: {
          light: "(color.runtime.accent.light.10)",
          dark: "(color.runtime.accent.dark.10)",
        },
      },
      highContrast: {
        key: "{palette.primary.highContrast}",
        $value: {
          light: "(color.runtime.accent.light.a12)",
          dark: "(color.runtime.accent.dark.a12)",
        },
      },
      backgroundSubtle: {
        key: "{palette.primary.backgroundSubtle}",
        $value: {
          light: "(color.runtime.accent.light.a2)",
          dark: "(color.runtime.accent.dark.a2)",
        },
      },
      backgroundSoftHover: {
        key: "{palette.primary.backgroundSoftHover}",
        $value: {
          light: "(color.runtime.accent.light.a4)",
          dark: "(color.runtime.accent.dark.a4)",
        },
      },
      backgroundSoftActive: {
        key: "{palette.primary.backgroundSoftActive}",
        $value: {
          light: "(color.runtime.accent.light.a5)",
          dark: "(color.runtime.accent.dark.a5)",
        },
      },
      borderStrong: {
        key: "{palette.primary.borderStrong}",
        $value: {
          light: "(color.runtime.accent.light.a8)",
          dark: "(color.runtime.accent.dark.a8)",
        },
      },
      backgroundSubtlest: {
        key: "{palette.primary.backgroundSubtlest}",
        $value: {
          light: "(color.runtime.accent.light.a1)",
          dark: "(color.runtime.accent.dark.a1)",
        },
      },
      onHighContrast: {
        key: "{palette.primary.onHighContrast}",
        $value: {
          light: "(color.runtime.accent.dark.12)",
          dark: "(color.runtime.accent.light.12)",
        },
      },
      textAccessible: {
        key: "{palette.primary.textAccessible}",
        $value: {
          light: "(color.runtime.accent.light.a11)",
          dark: "(color.runtime.accent.dark.a11)",
        },
      },
    },
    secondary: {
      1: {
        key: "{palette.secondary.1}",
        $value: {
          light: "(color.runtime.gray.light.1)",
          dark: "(color.runtime.gray.dark.1)",
        },
      },
      2: {
        key: "{palette.secondary.2}",
        $value: {
          light: "(color.runtime.gray.light.2)",
          dark: "(color.runtime.gray.dark.2)",
        },
      },
      3: {
        key: "{palette.secondary.3}",
        $value: {
          light: "(color.runtime.gray.light.3)",
          dark: "(color.runtime.gray.dark.3)",
        },
      },
      4: {
        key: "{palette.secondary.4}",
        $value: {
          light: "(color.runtime.gray.light.4)",
          dark: "(color.runtime.gray.dark.4)",
        },
      },
      5: {
        key: "{palette.secondary.5}",
        $value: {
          light: "(color.runtime.gray.light.5)",
          dark: "(color.runtime.gray.dark.5)",
        },
      },
      6: {
        key: "{palette.secondary.6}",
        $value: {
          light: "(color.runtime.gray.light.6)",
          dark: "(color.runtime.gray.dark.6)",
        },
      },
      7: {
        key: "{palette.secondary.7}",
        $value: {
          light: "(color.runtime.gray.light.7)",
          dark: "(color.runtime.gray.dark.7)",
        },
      },
      8: {
        key: "{palette.secondary.8}",
        $value: {
          light: "(color.runtime.gray.light.8)",
          dark: "(color.runtime.gray.dark.8)",
        },
      },
      9: {
        key: "{palette.secondary.9}",
        $value: {
          light: "(color.runtime.gray.light.9)",
          dark: "(color.runtime.gray.dark.9)",
        },
      },
      10: {
        key: "{palette.secondary.10}",
        $value: {
          light: "(color.runtime.gray.light.10)",
          dark: "(color.runtime.gray.dark.10)",
        },
      },
      11: {
        key: "{palette.secondary.11}",
        $value: {
          light: "(color.runtime.gray.light.11)",
          dark: "(color.runtime.gray.dark.11)",
        },
      },
      12: {
        key: "{palette.secondary.12}",
        $value: {
          light: "(color.runtime.gray.light.12)",
          dark: "(color.runtime.gray.dark.12)",
        },
      },
      50: {
        key: "{palette.secondary.50}",
        $value: {
          light: "(color.runtime.gray.light.2)",
          dark: "(color.runtime.gray.light.2)",
        },
      },
      100: {
        key: "{palette.secondary.100}",
        $value: {
          light: "(color.runtime.gray.light.3)",
          dark: "(color.runtime.gray.light.3)",
        },
      },
      200: {
        key: "{palette.secondary.200}",
        $value: {
          light: "(color.runtime.gray.light.5)",
          dark: "(color.runtime.gray.light.5)",
        },
      },
      300: {
        key: "{palette.secondary.300}",
        $value: {
          light: "(color.runtime.gray.light.8)",
          dark: "(color.runtime.gray.light.8)",
        },
      },
      400: {
        key: "{palette.secondary.400}",
        $value: {
          light: "(color.runtime.gray.light.9)",
          dark: "(color.runtime.gray.light.9)",
        },
      },
      500: {
        key: "{palette.secondary.500}",
        $value: {
          light: "(color.runtime.gray.light.11)",
          dark: "(color.runtime.gray.light.11)",
        },
      },
      600: {
        key: "{palette.secondary.600}",
        $value: {
          light: "(color.runtime.gray.dark.7)",
          dark: "(color.runtime.gray.dark.7)",
        },
      },
      700: {
        key: "{palette.secondary.700}",
        $value: {
          light: "(color.runtime.gray.dark.6)",
          dark: "(color.runtime.gray.dark.6)",
        },
      },
      800: {
        key: "{palette.secondary.800}",
        $value: {
          light: "(color.runtime.gray.dark.5)",
          dark: "(color.runtime.gray.dark.5)",
        },
      },
      900: {
        key: "{palette.secondary.900}",
        $value: {
          light: "(color.runtime.gray.dark.4)",
          dark: "(color.runtime.gray.dark.4)",
        },
      },
      950: {
        key: "{palette.secondary.950}",
        $value: {
          light: "(color.runtime.gray.dark.2)",
          dark: "(color.runtime.gray.dark.2)",
        },
      },
      lightest: {
        key: "{palette.secondary.lightest}",
        $value: {
          light: "(color.runtime.gray.light.4)",
          dark: "(color.runtime.gray.light.3)",
        },
      },
      light: {
        key: "{palette.secondary.light}",
        $value: {
          light: "(color.runtime.gray.light.8)",
          dark: "(color.runtime.gray.light.7)",
        },
      },
      main: {
        key: "{palette.secondary.main}",
        $value: {
          light: "(color.runtime.gray.light.11)",
          dark: "(color.runtime.gray.dark.11)",
        },
      },
      dark: {
        key: "{palette.secondary.dark}",
        $value: {
          light: "(color.runtime.gray.dark.7)",
          dark: "(color.runtime.gray.dark.8)",
        },
      },
      darkest: {
        key: "{palette.secondary.darkest}",
        $value: {
          light: "(color.runtime.gray.dark.5)",
          dark: "(color.runtime.gray.dark.6)",
        },
      },
      contrast: {
        key: "{palette.secondary.contrast}",
        $value: {
          light: "(color.runtime.gray.light.contrast)",
          dark: "(color.runtime.gray.dark.contrast)",
        },
      },
      borderRegular: {
        key: "{palette.secondary.borderRegular}",
        $value: {
          light: "(color.runtime.gray.light.a7)",
          dark: "(color.runtime.gray.dark.a7)",
        },
      },
      track: {
        key: "{palette.secondary.track}",
        $value: {
          light: "(color.runtime.gray.light.9)",
          dark: "(color.runtime.gray.dark.9)",
        },
      },
      a12: {
        key: "{palette.secondary.a12}",
        $value: {
          light: "(color.runtime.gray.light.a12)",
          dark: "(color.runtime.gray.dark.a12)",
        },
      },
      a10: {
        key: "{palette.secondary.a10}",
        $value: {
          light: "(color.runtime.gray.light.a10)",
          dark: "(color.runtime.gray.dark.a10)",
        },
      },
      a8: {
        key: "{palette.secondary.a8}",
        $value: {
          light: "(color.runtime.gray.light.a8)",
          dark: "(color.runtime.gray.dark.a8)",
        },
      },
      a7: {
        key: "{palette.secondary.a7}",
        $value: {
          light: "(color.runtime.gray.light.a7)",
          dark: "(color.runtime.gray.dark.a7)",
        },
      },
      a5: {
        key: "{palette.secondary.a5}",
        $value: {
          light: "(color.runtime.gray.light.a5)",
          dark: "(color.runtime.gray.dark.a5)",
        },
      },
      a2: {
        key: "{palette.secondary.a2}",
        $value: {
          light: "(color.runtime.gray.light.a2)",
          dark: "(color.runtime.gray.dark.a2)",
        },
      },
      a3: {
        key: "{palette.secondary.a3}",
        $value: {
          light: "(color.runtime.gray.light.a3)",
          dark: "(color.runtime.gray.dark.a3)",
        },
      },
      a1: {
        key: "{palette.secondary.a1}",
        $value: {
          light: "(color.runtime.gray.light.a1)",
          dark: "(color.runtime.gray.dark.a1)",
        },
      },
      a6: {
        key: "{palette.secondary.a6}",
        $value: {
          light: "(color.runtime.gray.light.a6)",
          dark: "(color.runtime.gray.dark.a6)",
        },
      },
      a11: {
        key: "{palette.secondary.a11}",
        $value: {
          light: "(color.runtime.gray.light.a11)",
          dark: "(color.runtime.gray.dark.a11)",
        },
      },
      a4: {
        key: "{palette.secondary.a4}",
        $value: {
          light: "(color.runtime.gray.light.a4)",
          dark: "(color.runtime.gray.dark.a4)",
        },
      },
      a9: {
        key: "{palette.secondary.a9}",
        $value: {
          light: "(color.runtime.gray.light.a9)",
          dark: "(color.runtime.gray.dark.a9)",
        },
      },
      indicator: {
        key: "{palette.secondary.indicator}",
        $value: {
          light: "(color.runtime.gray.light.9)",
          dark: "(color.runtime.gray.dark.9)",
        },
      },
      surface: {
        key: "{palette.secondary.surface}",
        $value: {
          light: "(color.runtime.gray.light.surface)",
          dark: "(color.runtime.gray.dark.surface)",
        },
      },
      backgroundSubtle: {
        key: "{palette.secondary.backgroundSubtle}",
        $value: {
          light: "(color.runtime.gray.light.a2)",
          dark: "(color.runtime.gray.dark.a2)",
        },
      },
      highContrast: {
        key: "{palette.secondary.highContrast}",
        $value: {
          light: "(color.runtime.gray.light.a12)",
          dark: "(color.runtime.gray.dark.a12)",
        },
      },
      text: {
        key: "{palette.secondary.text}",
        $value: {
          light: "(color.runtime.gray.light.a11)",
          dark: "(color.runtime.gray.dark.a11)",
        },
      },
      solid: {
        key: "{palette.secondary.solid}",
        $value: {
          light: "(color.runtime.gray.light.9)",
          dark: "(color.runtime.gray.dark.9)",
        },
      },
      backgroundSoft: {
        key: "{palette.secondary.backgroundSoft}",
        $value: {
          light: "(color.runtime.gray.light.a3)",
          dark: "(color.runtime.gray.dark.a3)",
        },
      },
      solidHover: {
        key: "{palette.secondary.solidHover}",
        $value: {
          light: "(color.runtime.gray.light.10)",
          dark: "(color.runtime.gray.dark.10)",
        },
      },
      borderSubtle: {
        key: "{palette.secondary.borderSubtle}",
        $value: {
          light: "(color.runtime.gray.light.a6)",
          dark: "(color.runtime.gray.dark.a6)",
        },
      },
      backgroundSubtlest: {
        key: "{palette.secondary.backgroundSubtlest}",
        $value: {
          light: "(color.runtime.gray.light.a1)",
          dark: "(color.runtime.gray.dark.a1)",
        },
      },
      backgroundSoftHover: {
        key: "{palette.secondary.backgroundSoftHover}",
        $value: {
          light: "(color.runtime.gray.light.a4)",
          dark: "(color.runtime.gray.dark.a4)",
        },
      },
      backgroundSoftActive: {
        key: "{palette.secondary.backgroundSoftActive}",
        $value: {
          light: "(color.runtime.gray.light.a5)",
          dark: "(color.runtime.gray.dark.a5)",
        },
      },
      borderStrong: {
        key: "{palette.secondary.borderStrong}",
        $value: {
          light: "(color.runtime.gray.light.a8)",
          dark: "(color.runtime.gray.dark.a8)",
        },
      },
      onHighContrast: {
        key: "{palette.secondary.onHighContrast}",
        $value: {
          light: "(color.runtime.gray.dark.12)",
          dark: "(color.runtime.gray.light.12)",
        },
      },
      textAccessible: {
        key: "{palette.secondary.textAccessible}",
        $value: {
          light: "(color.runtime.gray.light.a11)",
          dark: "(color.runtime.gray.dark.a11)",
        },
      },
    },
    info: {
      1: {
        key: "{palette.info.1}",
        $value: {
          light: "(color.runtime.gray.light.1)",
          dark: "(color.runtime.gray.dark.1)",
        },
      },
      2: {
        key: "{palette.info.2}",
        $value: {
          light: "(color.runtime.gray.light.2)",
          dark: "(color.runtime.gray.dark.2)",
        },
      },
      3: {
        key: "{palette.info.3}",
        $value: {
          light: "(color.runtime.gray.light.3)",
          dark: "(color.runtime.gray.dark.3)",
        },
      },
      4: {
        key: "{palette.info.4}",
        $value: {
          light: "(color.runtime.gray.light.4)",
          dark: "(color.runtime.gray.dark.4)",
        },
      },
      5: {
        key: "{palette.info.5}",
        $value: {
          light: "(color.runtime.gray.light.5)",
          dark: "(color.runtime.gray.dark.5)",
        },
      },
      6: {
        key: "{palette.info.6}",
        $value: {
          light: "(color.runtime.gray.light.6)",
          dark: "(color.runtime.gray.dark.6)",
        },
      },
      7: {
        key: "{palette.info.7}",
        $value: {
          light: "(color.runtime.gray.light.7)",
          dark: "(color.runtime.gray.dark.7)",
        },
      },
      8: {
        key: "{palette.info.8}",
        $value: {
          light: "(color.runtime.gray.light.8)",
          dark: "(color.runtime.gray.dark.8)",
        },
      },
      9: {
        key: "{palette.info.9}",
        $value: {
          light: "(color.runtime.gray.light.9)",
          dark: "(color.runtime.gray.dark.9)",
        },
      },
      10: {
        key: "{palette.info.10}",
        $value: {
          light: "(color.runtime.gray.light.10)",
          dark: "(color.runtime.gray.dark.10)",
        },
      },
      11: {
        key: "{palette.info.11}",
        $value: {
          light: "(color.runtime.gray.light.11)",
          dark: "(color.runtime.gray.dark.11)",
        },
      },
      12: {
        key: "{palette.info.12}",
        $value: {
          light: "(color.runtime.gray.light.12)",
          dark: "(color.runtime.gray.dark.12)",
        },
      },
      50: {
        key: "{palette.info.50}",
        $value: {
          light: "(color.runtime.gray.light.2)",
          dark: "(color.runtime.gray.light.2)",
        },
      },
      100: {
        key: "{palette.info.100}",
        $value: {
          light: "(color.runtime.gray.light.3)",
          dark: "(color.runtime.gray.light.3)",
        },
      },
      200: {
        key: "{palette.info.200}",
        $value: {
          light: "(color.runtime.gray.light.5)",
          dark: "(color.runtime.gray.light.5)",
        },
      },
      300: {
        key: "{palette.info.300}",
        $value: {
          light: "(color.runtime.gray.light.8)",
          dark: "(color.runtime.gray.light.8)",
        },
      },
      400: {
        key: "{palette.info.400}",
        $value: {
          light: "(color.runtime.gray.light.9)",
          dark: "(color.runtime.gray.light.9)",
        },
      },
      500: {
        key: "{palette.info.500}",
        $value: {
          light: "(color.runtime.gray.light.11)",
          dark: "(color.runtime.gray.light.11)",
        },
      },
      600: {
        key: "{palette.info.600}",
        $value: {
          light: "(color.runtime.gray.dark.7)",
          dark: "(color.runtime.gray.dark.7)",
        },
      },
      700: {
        key: "{palette.info.700}",
        $value: {
          light: "(color.runtime.gray.dark.6)",
          dark: "(color.runtime.gray.dark.6)",
        },
      },
      800: {
        key: "{palette.info.800}",
        $value: {
          light: "(color.runtime.gray.dark.5)",
          dark: "(color.runtime.gray.dark.5)",
        },
      },
      900: {
        key: "{palette.info.900}",
        $value: {
          light: "(color.runtime.gray.dark.4)",
          dark: "(color.runtime.gray.dark.4)",
        },
      },
      950: {
        key: "{palette.info.950}",
        $value: {
          light: "(color.runtime.gray.dark.2)",
          dark: "(color.runtime.gray.dark.2)",
        },
      },
      lightest: {
        key: "{palette.info.lightest}",
        $value: {
          light: "(color.runtime.gray.light.4)",
          dark: "(color.runtime.gray.light.3)",
        },
      },
      light: {
        key: "{palette.info.light}",
        $value: {
          light: "(color.runtime.gray.light.8)",
          dark: "(color.runtime.gray.light.7)",
        },
      },
      main: {
        key: "{palette.info.main}",
        $value: {
          light: "(color.runtime.gray.light.11)",
          dark: "(color.runtime.gray.dark.11)",
        },
      },
      dark: {
        key: "{palette.info.dark}",
        $value: {
          light: "(color.runtime.gray.dark.7)",
          dark: "(color.runtime.gray.dark.8)",
        },
      },
      darkest: {
        key: "{palette.info.darkest}",
        $value: {
          light: "(color.runtime.gray.dark.5)",
          dark: "(color.runtime.gray.dark.6)",
        },
      },
      contrast: {
        key: "{palette.info.contrast}",
        $value: {
          light: "(color.runtime.gray.light.contrast)",
          dark: "(color.runtime.gray.dark.contrast)",
        },
      },
      borderRegular: {
        key: "{palette.info.borderRegular}",
        $value: {
          light: "(color.runtime.gray.light.a7)",
          dark: "(color.runtime.gray.dark.a7)",
        },
      },
      a11: {
        key: "{palette.info.a11}",
        $value: {
          light: "(color.runtime.gray.light.a11)",
          dark: "(color.runtime.gray.dark.a11)",
        },
      },
      a1: {
        key: "{palette.info.a1}",
        $value: {
          light: "(color.runtime.gray.light.a1)",
          dark: "(color.runtime.gray.dark.a1)",
        },
      },
      a9: {
        key: "{palette.info.a9}",
        $value: {
          light: "(color.runtime.gray.light.a9)",
          dark: "(color.runtime.gray.dark.a9)",
        },
      },
      a12: {
        key: "{palette.info.a12}",
        $value: {
          light: "(color.runtime.gray.light.a12)",
          dark: "(color.runtime.gray.dark.a12)",
        },
      },
      a8: {
        key: "{palette.info.a8}",
        $value: {
          light: "(color.runtime.gray.light.a8)",
          dark: "(color.runtime.gray.dark.a8)",
        },
      },
      a5: {
        key: "{palette.info.a5}",
        $value: {
          light: "(color.runtime.gray.light.a5)",
          dark: "(color.runtime.gray.dark.a5)",
        },
      },
      a4: {
        key: "{palette.info.a4}",
        $value: {
          light: "(color.runtime.gray.light.a4)",
          dark: "(color.runtime.gray.dark.a4)",
        },
      },
      a2: {
        key: "{palette.info.a2}",
        $value: {
          light: "(color.runtime.gray.light.a2)",
          dark: "(color.runtime.gray.dark.a2)",
        },
      },
      a7: {
        key: "{palette.info.a7}",
        $value: {
          light: "(color.runtime.gray.light.a7)",
          dark: "(color.runtime.gray.dark.a7)",
        },
      },
      a6: {
        key: "{palette.info.a6}",
        $value: {
          light: "(color.runtime.gray.light.a6)",
          dark: "(color.runtime.gray.dark.a6)",
        },
      },
      a10: {
        key: "{palette.info.a10}",
        $value: {
          light: "(color.runtime.gray.light.a10)",
          dark: "(color.runtime.gray.dark.a10)",
        },
      },
      a3: {
        key: "{palette.info.a3}",
        $value: {
          light: "(color.runtime.gray.light.a3)",
          dark: "(color.runtime.gray.dark.a3)",
        },
      },
      indicator: {
        key: "{palette.info.indicator}",
        $value: {
          light: "(color.runtime.gray.light.9)",
          dark: "(color.runtime.gray.dark.9)",
        },
      },
      track: {
        key: "{palette.info.track}",
        $value: {
          light: "(color.runtime.gray.light.9)",
          dark: "(color.runtime.gray.dark.9)",
        },
      },
      surface: {
        key: "{palette.info.surface}",
        $value: {
          light: "(color.runtime.gray.light.surface)",
          dark: "(color.runtime.gray.dark.surface)",
        },
      },
      backgroundSubtle: {
        key: "{palette.info.backgroundSubtle}",
        $value: {
          light: "(color.runtime.gray.light.a2)",
          dark: "(color.runtime.gray.dark.a2)",
        },
      },
      highContrast: {
        key: "{palette.info.highContrast}",
        $value: {
          light: "(color.runtime.gray.light.a12)",
          dark: "(color.runtime.gray.dark.a12)",
        },
      },
      solidHover: {
        key: "{palette.info.solidHover}",
        $value: {
          light: "(color.runtime.gray.light.10)",
          dark: "(color.runtime.gray.dark.10)",
        },
      },
      solid: {
        key: "{palette.info.solid}",
        $value: {
          light: "(color.runtime.gray.light.9)",
          dark: "(color.runtime.gray.dark.9)",
        },
      },
      backgroundSoft: {
        key: "{palette.info.backgroundSoft}",
        $value: {
          light: "(color.runtime.gray.light.a3)",
          dark: "(color.runtime.gray.dark.a3)",
        },
      },
      text: {
        key: "{palette.info.text}",
        $value: {
          light: "(color.runtime.gray.light.a11)",
          dark: "(color.runtime.gray.dark.a11)",
        },
      },
      borderSubtle: {
        key: "{palette.info.borderSubtle}",
        $value: {
          light: "(color.runtime.gray.light.a6)",
          dark: "(color.runtime.gray.dark.a6)",
        },
      },
      backgroundSubtlest: {
        key: "{palette.info.backgroundSubtlest}",
        $value: {
          light: "(color.runtime.gray.light.a1)",
          dark: "(color.runtime.gray.dark.a1)",
        },
      },
      backgroundSoftHover: {
        key: "{palette.info.backgroundSoftHover}",
        $value: {
          light: "(color.runtime.gray.light.a4)",
          dark: "(color.runtime.gray.dark.a4)",
        },
      },
      backgroundSoftActive: {
        key: "{palette.info.backgroundSoftActive}",
        $value: {
          light: "(color.runtime.gray.light.a5)",
          dark: "(color.runtime.gray.dark.a5)",
        },
      },
      borderStrong: {
        key: "{palette.info.borderStrong}",
        $value: {
          light: "(color.runtime.gray.light.a8)",
          dark: "(color.runtime.gray.dark.a8)",
        },
      },
      onHighContrast: {
        key: "{palette.info.onHighContrast}",
        $value: {
          light: "(color.runtime.gray.dark.12)",
          dark: "(color.runtime.gray.light.12)",
        },
      },
      textAccessible: {
        key: "{palette.info.textAccessible}",
        $value: {
          light: "(color.runtime.gray.light.a11)",
          dark: "(color.runtime.gray.dark.a11)",
        },
      },
    },
    neutral: {
      1: {
        key: "{palette.neutral.1}",
        $value: {
          light: "(color.runtime.gray.light.1)",
          dark: "(color.runtime.gray.dark.1)",
        },
      },
      2: {
        key: "{palette.neutral.2}",
        $value: {
          light: "(color.runtime.gray.light.2)",
          dark: "(color.runtime.gray.dark.2)",
        },
      },
      3: {
        key: "{palette.neutral.3}",
        $value: {
          light: "(color.runtime.gray.light.3)",
          dark: "(color.runtime.gray.dark.3)",
        },
      },
      4: {
        key: "{palette.neutral.4}",
        $value: {
          light: "(color.runtime.gray.light.4)",
          dark: "(color.runtime.gray.dark.4)",
        },
      },
      5: {
        key: "{palette.neutral.5}",
        $value: {
          light: "(color.runtime.gray.light.5)",
          dark: "(color.runtime.gray.dark.5)",
        },
      },
      6: {
        key: "{palette.neutral.6}",
        $value: {
          light: "(color.runtime.gray.light.6)",
          dark: "(color.runtime.gray.dark.6)",
        },
      },
      7: {
        key: "{palette.neutral.7}",
        $value: {
          light: "(color.runtime.gray.light.7)",
          dark: "(color.runtime.gray.dark.7)",
        },
      },
      8: {
        key: "{palette.neutral.8}",
        $value: {
          light: "(color.runtime.gray.light.8)",
          dark: "(color.runtime.gray.dark.8)",
        },
      },
      9: {
        key: "{palette.neutral.9}",
        $value: {
          light: "(color.runtime.gray.light.9)",
          dark: "(color.runtime.gray.dark.9)",
        },
      },
      10: {
        key: "{palette.neutral.10}",
        $value: {
          light: "(color.runtime.gray.light.10)",
          dark: "(color.runtime.gray.dark.10)",
        },
      },
      11: {
        key: "{palette.neutral.11}",
        $value: {
          light: "(color.runtime.gray.light.11)",
          dark: "(color.runtime.gray.dark.11)",
        },
      },
      12: {
        key: "{palette.neutral.12}",
        $value: {
          light: "(color.runtime.gray.light.12)",
          dark: "(color.runtime.gray.dark.12)",
        },
      },
      50: {
        key: "{palette.neutral.50}",
        $value: {
          light: "(color.runtime.gray.light.2)",
          dark: "(color.runtime.gray.light.2)",
        },
      },
      100: {
        key: "{palette.neutral.100}",
        $value: {
          light: "(color.runtime.gray.light.3)",
          dark: "(color.runtime.gray.light.3)",
        },
      },
      200: {
        key: "{palette.neutral.200}",
        $value: {
          light: "(color.runtime.gray.light.5)",
          dark: "(color.runtime.gray.light.5)",
        },
      },
      300: {
        key: "{palette.neutral.300}",
        $value: {
          light: "(color.runtime.gray.light.8)",
          dark: "(color.runtime.gray.light.8)",
        },
      },
      400: {
        key: "{palette.neutral.400}",
        $value: {
          light: "(color.runtime.gray.light.9)",
          dark: "(color.runtime.gray.light.9)",
        },
      },
      500: {
        key: "{palette.neutral.500}",
        $value: {
          light: "(color.runtime.gray.light.11)",
          dark: "(color.runtime.gray.light.11)",
        },
      },
      600: {
        key: "{palette.neutral.600}",
        $value: {
          light: "(color.runtime.gray.dark.7)",
          dark: "(color.runtime.gray.dark.7)",
        },
      },
      700: {
        key: "{palette.neutral.700}",
        $value: {
          light: "(color.runtime.gray.dark.6)",
          dark: "(color.runtime.gray.dark.6)",
        },
      },
      800: {
        key: "{palette.neutral.800}",
        $value: {
          light: "(color.runtime.gray.dark.5)",
          dark: "(color.runtime.gray.dark.5)",
        },
      },
      900: {
        key: "{palette.neutral.900}",
        $value: {
          light: "(color.runtime.gray.dark.4)",
          dark: "(color.runtime.gray.dark.4)",
        },
      },
      950: {
        key: "{palette.neutral.950}",
        $value: {
          light: "(color.runtime.gray.dark.2)",
          dark: "(color.runtime.gray.dark.2)",
        },
      },
      a2: {
        key: "{palette.neutral.a2}",
        $value: {
          light: "(color.runtime.gray.light.a2)",
          dark: "(color.runtime.gray.dark.a2)",
        },
      },
      a1: {
        key: "{palette.neutral.a1}",
        $value: {
          light: "(color.runtime.gray.light.a1)",
          dark: "(color.runtime.gray.dark.a1)",
        },
      },
      a11: {
        key: "{palette.neutral.a11}",
        $value: {
          light: "(color.runtime.gray.light.a11)",
          dark: "(color.runtime.gray.dark.a11)",
        },
      },
      a8: {
        key: "{palette.neutral.a8}",
        $value: {
          light: "(color.runtime.gray.light.a8)",
          dark: "(color.runtime.gray.dark.a8)",
        },
      },
      a12: {
        key: "{palette.neutral.a12}",
        $value: {
          light: "(color.runtime.gray.light.a12)",
          dark: "(color.runtime.gray.dark.a12)",
        },
      },
      a9: {
        key: "{palette.neutral.a9}",
        $value: {
          light: "(color.runtime.gray.light.a9)",
          dark: "(color.runtime.gray.dark.a9)",
        },
      },
      a5: {
        key: "{palette.neutral.a5}",
        $value: {
          light: "(color.runtime.gray.light.a5)",
          dark: "(color.runtime.gray.dark.a5)",
        },
      },
      a4: {
        key: "{palette.neutral.a4}",
        $value: {
          light: "(color.runtime.gray.light.a4)",
          dark: "(color.runtime.gray.dark.a4)",
        },
      },
      a3: {
        key: "{palette.neutral.a3}",
        $value: {
          light: "(color.runtime.gray.light.a3)",
          dark: "(color.runtime.gray.dark.a3)",
        },
      },
      a7: {
        key: "{palette.neutral.a7}",
        $value: {
          light: "(color.runtime.gray.light.a7)",
          dark: "(color.runtime.gray.dark.a7)",
        },
      },
      a6: {
        key: "{palette.neutral.a6}",
        $value: {
          light: "(color.runtime.gray.light.a6)",
          dark: "(color.runtime.gray.dark.a6)",
        },
      },
      a10: {
        key: "{palette.neutral.a10}",
        $value: {
          light: "(color.runtime.gray.light.a10)",
          dark: "(color.runtime.gray.dark.a10)",
        },
      },
      track: {
        key: "{palette.neutral.track}",
        $value: {
          light: "(color.runtime.gray.light.9)",
          dark: "(color.runtime.gray.dark.9)",
        },
      },
      indicator: {
        key: "{palette.neutral.indicator}",
        $value: {
          light: "(color.runtime.gray.light.9)",
          dark: "(color.runtime.gray.dark.9)",
        },
      },
      surface: {
        key: "{palette.neutral.surface}",
        $value: {
          light: "(color.runtime.gray.light.surface)",
          dark: "(color.runtime.gray.dark.surface)",
        },
      },
      contrast: {
        key: "{palette.neutral.contrast}",
        $value: {
          light: "(color.runtime.gray.light.contrast)",
          dark: "(color.runtime.gray.dark.contrast)",
        },
      },
      backgroundSubtle: {
        key: "{palette.neutral.backgroundSubtle}",
        $value: {
          light: "(color.runtime.gray.light.a2)",
          dark: "(color.runtime.gray.dark.a2)",
        },
      },
      highContrast: {
        key: "{palette.neutral.highContrast}",
        $value: {
          light: "(color.runtime.gray.light.a12)",
          dark: "(color.runtime.gray.dark.a12)",
        },
      },
      text: {
        key: "{palette.neutral.text}",
        $value: {
          light: "(color.runtime.gray.light.a11)",
          dark: "(color.runtime.gray.dark.a11)",
        },
      },
      solid: {
        key: "{palette.neutral.solid}",
        $value: {
          light: "(color.runtime.gray.light.9)",
          dark: "(color.runtime.gray.dark.9)",
        },
      },
      backgroundSoft: {
        key: "{palette.neutral.backgroundSoft}",
        $value: {
          light: "(color.runtime.gray.light.a3)",
          dark: "(color.runtime.gray.dark.a3)",
        },
      },
      solidHover: {
        key: "{palette.neutral.solidHover}",
        $value: {
          light: "(color.runtime.gray.light.10)",
          dark: "(color.runtime.gray.dark.10)",
        },
      },
      borderSubtle: {
        key: "{palette.neutral.borderSubtle}",
        $value: {
          light: "(color.runtime.gray.light.a6)",
          dark: "(color.runtime.gray.dark.a6)",
        },
      },
      borderRegular: {
        key: "{palette.neutral.borderRegular}",
        $value: {
          light: "(color.runtime.gray.light.a7)",
          dark: "(color.runtime.gray.dark.a7)",
        },
      },
      main: {
        key: "{palette.neutral.main}",
        $value: {
          light: "(color.runtime.gray.light.11)",
          dark: "(color.runtime.gray.dark.11)",
        },
      },
      dark: {
        key: "{palette.neutral.dark}",
        $value: {
          light: "(color.runtime.gray.dark.7)",
          dark: "(color.runtime.gray.dark.8)",
        },
      },
      light: {
        key: "{palette.neutral.light}",
        $value: {
          light: "(color.runtime.gray.light.8)",
          dark: "(color.runtime.gray.light.7)",
        },
      },
      darkest: {
        key: "{palette.neutral.darkest}",
        $value: {
          light: "(color.runtime.gray.dark.5)",
          dark: "(color.runtime.gray.dark.6)",
        },
      },
      lightest: {
        key: "{palette.neutral.lightest}",
        $value: {
          light: "(color.runtime.gray.light.4)",
          dark: "(color.runtime.gray.light.3)",
        },
      },
      backgroundSubtlest: {
        key: "{palette.neutral.backgroundSubtlest}",
        $value: {
          light: "(color.runtime.gray.light.a1)",
          dark: "(color.runtime.gray.dark.a1)",
        },
      },
      backgroundSoftHover: {
        key: "{palette.neutral.backgroundSoftHover}",
        $value: {
          light: "(color.runtime.gray.light.a4)",
          dark: "(color.runtime.gray.dark.a4)",
        },
      },
      backgroundSoftActive: {
        key: "{palette.neutral.backgroundSoftActive}",
        $value: {
          light: "(color.runtime.gray.light.a5)",
          dark: "(color.runtime.gray.dark.a5)",
        },
      },
      borderStrong: {
        key: "{palette.neutral.borderStrong}",
        $value: {
          light: "(color.runtime.gray.light.a8)",
          dark: "(color.runtime.gray.dark.a8)",
        },
      },
      onHighContrast: {
        key: "{palette.neutral.onHighContrast}",
        $value: {
          light: "(color.runtime.gray.dark.12)",
          dark: "(color.runtime.gray.light.12)",
        },
      },
      textAccessible: {
        key: "{palette.neutral.textAccessible}",
        $value: {
          light: "(color.runtime.gray.light.a11)",
          dark: "(color.runtime.gray.dark.a11)",
        },
      },
    },
    darkToLight: {
      key: "{palette.darkToLight}",
      $value: {
        light: "(color.runtime.gray.light.12)",
        dark: "#ffffff",
      },
    },
  },
  color: {
    runtime: {
      accent: {
        light: {
          1: {
            key: "{color.runtime.accent.light.1}",
            $value: "#fdfdff",
          },
          2: {
            key: "{color.runtime.accent.light.2}",
            $value: "#f8f8ff",
          },
          3: {
            key: "{color.runtime.accent.light.3}",
            $value: "#f0f1ff",
          },
          4: {
            key: "{color.runtime.accent.light.4}",
            $value: "#e5e6ff",
          },
          5: {
            key: "{color.runtime.accent.light.5}",
            $value: "#d9dbff",
          },
          6: {
            key: "{color.runtime.accent.light.6}",
            $value: "#caccff",
          },
          7: {
            key: "{color.runtime.accent.light.7}",
            $value: "#b6b7ff",
          },
          8: {
            key: "{color.runtime.accent.light.8}",
            $value: "#9c99ff",
          },
          9: {
            key: "{color.runtime.accent.light.9}",
            $value: "#7560ff",
          },
          10: {
            key: "{color.runtime.accent.light.10}",
            $value: "#6a51f0",
          },
          11: {
            key: "{color.runtime.accent.light.11}",
            $value: "#5d47d7",
          },
          12: {
            key: "{color.runtime.accent.light.12}",
            $value: "#2c226c",
          },
          a11: {
            key: "{color.runtime.accent.light.a11}",
            $value: "#1f00c8b8",
          },
          a12: {
            key: "{color.runtime.accent.light.a12}",
            $value: "#0c0055de",
          },
          a9: {
            key: "{color.runtime.accent.light.a9}",
            $value: "#2200ff9e",
          },
          a8: {
            key: "{color.runtime.accent.light.a8}",
            $value: "#0800ff66",
          },
          surface: {
            key: "{color.runtime.accent.light.surface}",
            $value: "#f6f6ffcc",
          },
          a2: {
            key: "{color.runtime.accent.light.a2}",
            $value: "#0000ff08",
          },
          a10: {
            key: "{color.runtime.accent.light.a10}",
            $value: "#2500e9ad",
          },
          a7: {
            key: "{color.runtime.accent.light.a7}",
            $value: "#0004ff4a",
          },
          a6: {
            key: "{color.runtime.accent.light.a6}",
            $value: "#000aff36",
          },
          contrast: {
            key: "{color.runtime.accent.light.contrast}",
            $value: "#ffffff",
          },
          a4: {
            key: "{color.runtime.accent.light.a4}",
            $value: "#000aff1a",
          },
          a3: {
            key: "{color.runtime.accent.light.a3}",
            $value: "#0011ff0f",
          },
          a5: {
            key: "{color.runtime.accent.light.a5}",
            $value: "#000eff26",
          },
          a1: {
            key: "{color.runtime.accent.light.a1}",
            $value: "#0000ff03",
          },
        },
        dark: {
          1: {
            key: "{color.runtime.accent.dark.1}",
            $value: "#080815",
          },
          2: {
            key: "{color.runtime.accent.dark.2}",
            $value: "#141327",
          },
          3: {
            key: "{color.runtime.accent.dark.3}",
            $value: "#221d50",
          },
          4: {
            key: "{color.runtime.accent.dark.4}",
            $value: "#2d2072",
          },
          5: {
            key: "{color.runtime.accent.dark.5}",
            $value: "#372983",
          },
          6: {
            key: "{color.runtime.accent.dark.6}",
            $value: "#413592",
          },
          7: {
            key: "{color.runtime.accent.dark.7}",
            $value: "#4d41a7",
          },
          8: {
            key: "{color.runtime.accent.dark.8}",
            $value: "#5c4ec7",
          },
          9: {
            key: "{color.runtime.accent.dark.9}",
            $value: "#7560ff",
          },
          10: {
            key: "{color.runtime.accent.dark.10}",
            $value: "#6a51f0",
          },
          11: {
            key: "{color.runtime.accent.dark.11}",
            $value: "#aaa9ff",
          },
          12: {
            key: "{color.runtime.accent.dark.12}",
            $value: "#dddfff",
          },
          a10: {
            key: "{color.runtime.accent.dark.a10}",
            $value: "#7055fef0",
          },
          contrast: {
            key: "{color.runtime.accent.dark.contrast}",
            $value: "#ffffff",
          },
          a11: {
            key: "{color.runtime.accent.dark.a11}",
            $value: "#aaa9ff",
          },
          a9: {
            key: "{color.runtime.accent.dark.a9}",
            $value: "#7560ff",
          },
          a7: {
            key: "{color.runtime.accent.dark.a7}",
            $value: "#735ffea3",
          },
          a8: {
            key: "{color.runtime.accent.dark.a8}",
            $value: "#7563fec4",
          },
          a5: {
            key: "{color.runtime.accent.dark.a5}",
            $value: "#6649fd7d",
          },
          a12: {
            key: "{color.runtime.accent.dark.a12}",
            $value: "#dddfff",
          },
          a1: {
            key: "{color.runtime.accent.dark.a1}",
            $value: "#0000f30a",
          },
          a2: {
            key: "{color.runtime.accent.dark.a2}",
            $value: "#6757fa1f",
          },
          a6: {
            key: "{color.runtime.accent.dark.a6}",
            $value: "#6e58fe8f",
          },
          a3: {
            key: "{color.runtime.accent.dark.a3}",
            $value: "#614dfd4a",
          },
          surface: {
            key: "{color.runtime.accent.dark.surface}",
            $value: "#1f1c4380",
          },
          a4: {
            key: "{color.runtime.accent.dark.a4}",
            $value: "#5e3eff6b",
          },
        },
      },
      gray: {
        light: {
          1: {
            key: "{color.runtime.gray.light.1}",
            $value: "#fcfcfd",
          },
          2: {
            key: "{color.runtime.gray.light.2}",
            $value: "#f8f9fa",
          },
          3: {
            key: "{color.runtime.gray.light.3}",
            $value: "#eff0f2",
          },
          4: {
            key: "{color.runtime.gray.light.4}",
            $value: "#e7e8ea",
          },
          5: {
            key: "{color.runtime.gray.light.5}",
            $value: "#dfe1e3",
          },
          6: {
            key: "{color.runtime.gray.light.6}",
            $value: "#d8dadd",
          },
          7: {
            key: "{color.runtime.gray.light.7}",
            $value: "#cccfd2",
          },
          8: {
            key: "{color.runtime.gray.light.8}",
            $value: "#b8bcc0",
          },
          9: {
            key: "{color.runtime.gray.light.9}",
            $value: "#8a8e92",
          },
          10: {
            key: "{color.runtime.gray.light.10}",
            $value: "#808487",
          },
          11: {
            key: "{color.runtime.gray.light.11}",
            $value: "#616467",
          },
          12: {
            key: "{color.runtime.gray.light.12}",
            $value: "#1e2022",
          },
          contrast: {
            key: "{color.runtime.gray.light.contrast}",
            $value: "#ffffff",
          },
          a10: {
            key: "{color.runtime.gray.light.a10}",
            $value: "#00090f80",
          },
          a7: {
            key: "{color.runtime.gray.light.a7}",
            $value: "#000f1e33",
          },
          a6: {
            key: "{color.runtime.gray.light.a6}",
            $value: "#000e2126",
          },
          a5: {
            key: "{color.runtime.gray.light.a5}",
            $value: "#00102021",
          },
          a4: {
            key: "{color.runtime.gray.light.a4}",
            $value: "#000b2017",
          },
          a3: {
            key: "{color.runtime.gray.light.a3}",
            $value: "#0010300f",
          },
          a2: {
            key: "{color.runtime.gray.light.a2}",
            $value: "#00254908",
          },
          a1: {
            key: "{color.runtime.gray.light.a1}",
            $value: "#00005503",
          },
          a9: {
            key: "{color.runtime.gray.light.a9}",
            $value: "#00091275",
          },
          a11: {
            key: "{color.runtime.gray.light.a11}",
            $value: "#00050a9e",
          },
          surface: {
            key: "{color.runtime.gray.light.surface}",
            $value: "#ffffffcc",
          },
          a12: {
            key: "{color.runtime.gray.light.a12}",
            $value: "#000205e0",
          },
          a8: {
            key: "{color.runtime.gray.light.a8}",
            $value: "#000f1d47",
          },
        },
        dark: {
          1: {
            key: "{color.runtime.gray.dark.1}",
            $value: "#090a0b",
          },
          2: {
            key: "{color.runtime.gray.dark.2}",
            $value: "#161718",
          },
          3: {
            key: "{color.runtime.gray.dark.3}",
            $value: "#202223",
          },
          4: {
            key: "{color.runtime.gray.dark.4}",
            $value: "#27292b",
          },
          5: {
            key: "{color.runtime.gray.dark.5}",
            $value: "#2f3132",
          },
          6: {
            key: "{color.runtime.gray.dark.6}",
            $value: "#373a3c",
          },
          7: {
            key: "{color.runtime.gray.dark.7}",
            $value: "#45484b",
          },
          8: {
            key: "{color.runtime.gray.dark.8}",
            $value: "#5c6165",
          },
          9: {
            key: "{color.runtime.gray.dark.9}",
            $value: "#686e73",
          },
          10: {
            key: "{color.runtime.gray.dark.10}",
            $value: "#757b81",
          },
          11: {
            key: "{color.runtime.gray.dark.11}",
            $value: "#b0b4b8",
          },
          12: {
            key: "{color.runtime.gray.dark.12}",
            $value: "#edeeef",
          },
          surface: {
            key: "{color.runtime.gray.dark.surface}",
            $value: "#00000000",
          },
          a10: {
            key: "{color.runtime.gray.dark.a10}",
            $value: "#e7f3fd7d",
          },
          a9: {
            key: "{color.runtime.gray.dark.a9}",
            $value: "#e8f4ff6e",
          },
          a6: {
            key: "{color.runtime.gray.dark.a6}",
            $value: "#ebf6fc33",
          },
          a4: {
            key: "{color.runtime.gray.dark.a4}",
            $value: "#eaf3fb21",
          },
          a3: {
            key: "{color.runtime.gray.dark.a3}",
            $value: "#ebf6f71a",
          },
          a2: {
            key: "{color.runtime.gray.dark.a2}",
            $value: "#f5f7f80d",
          },
          a1: {
            key: "{color.runtime.gray.dark.a1}",
            $value: "#00000000",
          },
          a11: {
            key: "{color.runtime.gray.dark.a11}",
            $value: "#f4faffb5",
          },
          a7: {
            key: "{color.runtime.gray.dark.a7}",
            $value: "#edf6ff42",
          },
          a8: {
            key: "{color.runtime.gray.dark.a8}",
            $value: "#e8f4fd5e",
          },
          a12: {
            key: "{color.runtime.gray.dark.a12}",
            $value: "#fcfdfef0",
          },
          contrast: {
            key: "{color.runtime.gray.dark.contrast}",
            $value: "#ffffff",
          },
          a5: {
            key: "{color.runtime.gray.dark.a5}",
            $value: "#f5fdfe29",
          },
        },
      },
    },
  },
};
